import React from "react";
import Reveal from "../motion/Reveal";
import { workflow } from "../../data/content";

/**
 * Numbered manifesto chapters with enormous faint numerals in the background.
 */
export default function Workflow() {
  return (
    <section
      className="relative bg-white py-32 lg:py-44 border-t border-brand-border"
      data-testid="workflow-section"
    >
      <div className="max-w-[90rem] mx-auto px-6 sm:px-8 lg:px-12">
        <div className="max-w-3xl">
          <Reveal>
            <p className="eyebrow">Vorgehen</p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 font-display font-medium text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-balance">
              Fünf Kapitel.
              <br />
              <span className="text-brand-muted">
                Kein Wasserfall. Kein Ping-Pong.
              </span>
            </h2>
          </Reveal>
        </div>

        <ol className="mt-20 lg:mt-28">
          {workflow.map((w, i) => (
            <Reveal key={w.n} delay={i * 0.05}>
              <li
                className="relative grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 py-12 lg:py-16 border-t border-brand-border"
                data-testid={`workflow-step-${w.n}`}
              >
                {/* Giant faint numeral */}
                <span
                  aria-hidden
                  className="absolute -top-4 lg:-top-10 right-4 lg:right-12 select-none pointer-events-none font-display font-bold text-[6rem] sm:text-[10rem] lg:text-[16rem] leading-none tracking-tighter"
                  style={{ color: "#F1F5F9" }}
                >
                  {w.n}
                </span>

                <div className="lg:col-span-4 relative z-10">
                  <div className="text-xs uppercase tracking-widest text-brand-accent font-semibold">
                    Kapitel {w.n}
                  </div>
                  <h3 className="mt-3 font-display font-medium text-3xl lg:text-5xl tracking-tighter leading-[1] text-brand-primary">
                    {w.title}
                  </h3>
                </div>

                <div className="lg:col-span-6 relative z-10">
                  <p className="text-lg lg:text-xl text-brand-primary/80 leading-relaxed text-balance">
                    {w.body}
                  </p>
                </div>

                <div className="lg:col-span-2 relative z-10">
                  <div className="text-xs uppercase tracking-widest text-brand-muted">
                    Dauer
                  </div>
                  <div className="mt-2 text-brand-primary font-medium">
                    {w.duration}
                  </div>
                </div>
              </li>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
}
